export const contractorStatusVariant = (status: string) => {
  switch (status) {
    case "pending_approval":
      return { yellow: true };
    case "approved":
      return { neutral: true };
    case "deleted":
      return { danger: true };
    case "rejected":
      return { danger: true };
    default:
      return { neutral: true };
  }
};

export const oemStatusVariant = (status: string) => {
  switch (status) {
    case "pending_approval":
      return { yellow: true };
    case "approved":
      return { neutral: true };
    case "rejected":
      return { danger: true };
    case "deleted":
      return { danger: true };
    default:
      return { neutral: true };
  }
};

export const customerStatusVariant = (status: string) => {
  switch (status) {
    case "Active":
      return { neutral: true };
    case "Pending":
      return { yellow: true };
    case "Rejected":
      return { danger: true };
    case "Inactive":
      return { neutral: true };
    default:
      return { neutral: true };
  }
};
